<script lang="ts" setup>
import ParagrahNote from '../../ParagrahNote.vue';
import WhereToConsultCard from '../../WhereToConsult/WhereToConsultCard.vue';
import HomePurchaseDataImg from '/home/runner/_work/shadow/shadow/packages/app/node_modules/.cache/home/runner/_work/shadow/shadow/packages/app/src/components/templates/ProductLpTemplate/mortgage/WhereToConsultCard/01_home_purchase_data.png/01_home_purchase_data.webp';
import OwnFundsImg from '/home/runner/_work/shadow/shadow/packages/app/node_modules/.cache/home/runner/_work/shadow/shadow/packages/app/src/components/templates/ProductLpTemplate/mortgage/WhereToConsultCard/02_own_funds.jpg/02_own_funds.webp';
import PinchImageModal from '~theme/components/organisms/PinchImageModal.vue';

defineProps<{
  imageNumber: number;
}>();
</script>

<template>
  <WhereToConsultCard
    title="住宅購入時の平均年齢・購入金額・世帯年収とは"
    :image-number="imageNumber"
  >
    <p>
      「年収の5倍」および「返済負担率25％」が住宅ローンの借入額の一つの目安と言われていますが、国土交通省が調査した世帯主の住宅購入時データ（※）によると、住宅タイプ別の購入資金の平均額は以下の通りです。
    </p>
    <PinchImageModal :src="HomePurchaseDataImg" />
    <p>
      住宅購入時の世帯主の平均年齢は<strong>30代後半～40代前半</strong>、平均購入資金は<strong>3,000～5,000万円</strong>、住宅購入時の平均世帯年収は<strong>約600～900万円</strong>でした。
    </p>
    <p>
      このことから、あくまでも目安ですが「世帯年収が600万円以上あれば住宅購入を現実的に考えることができる」と捉えてよいでしょう。
    </p>
    <ParagrahNote>
      ※参照：<NuxtLink
        href="https://www.mlit.go.jp/report/press/content/001610299.pdf#page=43"
        external
        target="_blank"
        >令和4年度 住宅市場同行調査 報告書 38、42、44ページ｜国土交通省
        住宅局</NuxtLink
      >
    </ParagrahNote>

    <h3>頭金はどのくらい用意すればいい？</h3>
    <p>
      頭金を用意すると住宅ローンの借入額が減るため、支払う利息が最小限で済みますが、頭金を用意するよりもフルローンで借入した方が住宅ローンの控除額は大きいです。また、フルローンで借入し、手元に残ったお金は繰り上げ返済に利用する方が、お得になる場合もあります。
    </p>
    <p>
      オカネコが行ったアンケート調査によると、住宅購入時の「自己資金はない」と回答した方が16.8%と最も多く、次いで自己資金1割未満と回答した方が16.6%という結果でした。
    </p>
    <PinchImageModal :src="OwnFundsImg" />
    <p>
      3人に1人は「マイホーム購入時の自己資金1割未満」で購入していることがわかります。
    </p>
    <p>
      頭金を用意した場合とフルローン、どちらがお得になるかは借入額などによって異なるため、シミュレーションをすることが重要です。
    </p>
    <ParagrahNote>
      ※参照：<NuxtLink
        href="https://okane-kenko.jp/media/survey_2405-01/"
        external
        target="_blank"
        >【オカネコ
        マイホームに関する意識調査】世帯年収600万円を超えると過半数が所有！日銀マイナス金利解除を受け、約3人に1人が「購入希望時期を早めたい」</NuxtLink
      >
    </ParagrahNote>
  </WhereToConsultCard>
</template>

<style module lang="scss"></style>
